import React, { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useUserData } from '@components/UserData';
import { Innovate } from './innovate';
import Scientist from './scientist';
import { Layout } from './_components/Layout';
import { Provider, useSimpleContext } from './_context';
import { useData } from './_context/useData';

const Style = createGlobalStyle`
  .body {
    .t-tip-toast {
      padding-top: 6px;
      .has-tip {
      }
    }
  }
`;

const Apply = () => {
  const {
    state: {
      formType,
      isViewType,
    },
  } = useSimpleContext((t) => [t.formType]);
  const {
    applyFlag,
  } = useUserData();
  const history = useHistory();
  useData();

  useEffect(() => {
    if (applyFlag) {
      history.replace({
        pathname: '/preview',
        search: `formType=${formType || 'scientist'}`,
      });
    }
  }, [applyFlag, formType, history]);

  return (
    <Layout className={isViewType ? 'viewType' : ''}>
      {formType === 'scientist' ? <Scientist /> : <Innovate />}
      <Style />
      <div id="test-tip" />
    </Layout>
  );
};

export default () => {
  const { params } = useRouteMatch();
  return (
    <Provider value={{ formType: params.formType }}>
      <Apply />
    </Provider>
  );
};
